import React, { useState } from 'react';
import { useFormikContext, getIn } from 'formik';

import { LinterSuggerimento, LaTeX, RealTeXLoad } from './'
import { Linter } from '../api/types'
import { build_tex_problema_post } from '../api';

type CallFunc = (val: Parameters<typeof build_tex_problema_post>[1]) => ReturnType<typeof build_tex_problema_post>;

interface IProps {
  fieldname: string,
  lints?: Linter[],
  latex_api?: CallFunc,
  mode?: 'live' | 'compiled' | 'combined',
}

const AnteprimaLaTeX = ({ fieldname, lints, latex_api, mode = 'combined' }: IProps) => {
  const [iteration, setIteration] = useState(0);
  const { values } = useFormikContext();
  const text = getIn(values, fieldname) || '';
  const showLive = mode !== 'compiled';
  const showCompiled = mode !== 'live';

  return (
    <div className={mode === 'live' ? 'card flex-grow-1' : 'card my-1'} style={mode === 'live'
      ? { minHeight: 'var(--latex-preview-min-height, 250px)', borderColor: 'var(--latex-frame-border, #94a3b8)' }
      : undefined}>
      <div className="card-body">
        <h5 className="card-title">{mode === 'live' ? 'Anteprima in tempo reale' : mode === 'compiled' ? 'Anteprima LaTeX compilata' : 'Anteprima'}</h5>
        {showLive && <>
          <p className="small text-muted">L’anteprima si aggiorna mentre scrivi. Inserisci le formule tra <code>$ $</code> oppure <code>{'\\[ \\]'}</code>.</p>
          {text ? <LaTeX text={text} /> : <p className="text-muted mb-0">Inizia a scrivere per vedere l’anteprima.</p>}
          {lints && lints.length > 0 && <>
            <hr />
            <h6>Suggerimenti stilistici</h6>
            {lints.map((lint, idx) => <LinterSuggerimento key={idx} fieldname={fieldname} suggerimento={lint} />)}
          </>}
        </>}
        {showCompiled && <>
          {latex_api ? <>
            <RealTeXLoad id={1} api={() => latex_api({ override: text })} callback={() => {}} force_refresh={iteration} />
            <button className="btn btn-info mt-2" type="button" onClick={() => setIteration(val => val + 1)}><i className="fa fa-gear" aria-hidden="true" /> Ricompila</button>
          </> : <p className="text-muted mb-0">La compilazione LaTeX sarà disponibile dopo la pubblicazione del problema.</p>}
        </>}
      </div>
    </div>
  );
};

export default AnteprimaLaTeX;
